const replaceAllInserter = require('string.prototype.replaceall');

if (!String.prototype.replaceAll) {
    replaceAllInserter.shim();
}
